import { Datagrid, FunctionField, List, Pagination } from "react-admin";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { RaRowActions } from "../../components/RaRowActions";
import {
  datagridSx,
  listCardSx,
  rowTitleSx,
} from "../../components/listStyles";
import { colors, fontFamilyMono } from "../../data/tokens";
import { roleLabel } from "../../util/roleLabel";
import {
  PermissionChips,
  ProfileChip,
  roleDeleteBlockReason,
  useRoleUserCount,
} from "./userRoleMeta";

// Nome traduzido em destaque; o nome gravado (usado pelo sistema) embaixo,
// em fonte técnica, quando a tradução difere
const RoleName = ({ name }: { name?: string }) => {
  const label = roleLabel(name);
  return (
    <Box>
      <Typography sx={rowTitleSx}>{label}</Typography>
      {label !== name && (
        <Typography
          sx={{ fontSize: 11.5, color: colors.textMuted, fontFamily: fontFamilyMono }}
        >
          {name}
        </Typography>
      )}
    </Box>
  );
};

const RoleUserCount = ({ roleId }: { roleId: string }) => {
  const { count } = useRoleUserCount(roleId);
  return (
    <Typography sx={{ fontSize: 13, fontWeight: 600, color: colors.textStrong }}>
      {count === undefined ? "…" : count.toLocaleString("pt-BR")}
    </Typography>
  );
};

const RoleActions = ({ record }: { record: any }) => {
  const { count } = useRoleUserCount(record.id);
  return (
    <RaRowActions delDisabledReason={roleDeleteBlockReason(record.name, count)} />
  );
};

// Padrão das listas do painel: clicar na linha abre a ficha; Editar/
// Excluir visíveis (antes atrás do menu "⋮"). As permissões, antes um
// JSON cru ("ADMIN_MANAGE_ANY_ANYTHING"), viram etiquetas em português, e
// cada regra mostra o perfil que o painel aplica e quantos usuários tem.
// Sem exclusão em massa: ela passaria por cima das proteções da linha
// (regra em uso ou usada pelo sistema) — e são só 7 regras.
export const UserRolesList = () => {
  return (
    <>
      <PageTopBreadcrumb
        title="Regras de Usuário"
        firstPath="/#/user-roles/crud"
        actionType="create"
      />
      <List
        actions={false}
        perPage={25}
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50]} />}
        queryOptions={{ keepPreviousData: true }}
        sx={listCardSx}
      >
        <Datagrid rowClick="show" bulkActionButtons={false} sx={datagridSx}>
          {/* sortable={false}: a API desta tela ignora a ordenação */}
          <FunctionField
            label="Regra"
            sortable={false}
            render={(record: any) => <RoleName name={record.name} />}
          />
          <FunctionField
            label="Perfil no painel"
            sortable={false}
            render={(record: any) => (
              <ProfileChip permissions={record.permissions} />
            )}
          />
          <FunctionField
            label="Permissões"
            sortable={false}
            render={(record: any) => (
              <PermissionChips permissions={record.permissions} />
            )}
          />
          <FunctionField
            label="Usuários"
            sortable={false}
            textAlign="right"
            render={(record: any) => <RoleUserCount roleId={record.id} />}
          />
          <FunctionField
            label="Ações"
            textAlign="right"
            render={(record: any) => <RoleActions record={record} />}
          />
        </Datagrid>
      </List>
    </>
  );
};
